export default __webpack_public_path__ + "fe65b27.png";